import { Trans, useTranslation } from 'react-i18next';

import { useUser } from '~/api/user';
import { Dialog, Header, Text, Title } from '~/components';
import { EnableCommunityProfileDialog } from '~/features/community';
import { routes } from '~/providers/RouterProvider/router.routes';

import { ForumHeaderPortal } from '../components/ForumHeaderPortal';
import { CreateForumPostDialog } from '../CreateForumPostDialog/CreateForumPostDialog';
import { contentStyle, paragraphStyle, subtitleStyle, wrapperStyle } from './ForumGuidelines.css';

export const ForumGuidelines = () => {
  const { data: user } = useUser();

  const createPostDialogHandle = Dialog.useHandle();
  const enableCommunityProfileHandle = Dialog.useHandle();

  const { t } = useTranslation(['forum']);

  return (
    <>
      <ForumHeaderPortal>
        <Header.Root>
          <Header.Content backTo={routes.forumTimeline} title={t('forum:guidelines.header.title')} />
          <Header.Actions>
            <Header.Action
              icon="Add"
              onClick={() => (user.communityProfile.enabled ? createPostDialogHandle.open(null) : enableCommunityProfileHandle.open(null))}
            >
              {t('forum:createPost.title')}
            </Header.Action>
          </Header.Actions>
        </Header.Root>
      </ForumHeaderPortal>

      <div className={wrapperStyle}>
        <div className={contentStyle}>
          <Trans
            components={{
              introduction: <Text />,
              subtitle: <Title as="h3" className={subtitleStyle} />,
              paragraph: <Text className={paragraphStyle} />,
            }}
            i18nKey="forum:guidelines.content"
          />
        </div>

        <Dialog.Root handle={createPostDialogHandle}>
          <CreateForumPostDialog onClose={() => createPostDialogHandle.close()} />
        </Dialog.Root>

        <Dialog.Root handle={enableCommunityProfileHandle}>
          <EnableCommunityProfileDialog />
        </Dialog.Root>
      </div>
    </>
  );
};
